/* eslint-disable camelcase */
import PropTypes from 'prop-types';

import {
  propTypesIllustration,
  propTypesTextHtml,
} from '../../../constants/Proptypes';

const propTypesSliceBenchmarkGrid = {
  benchmark_grid_slice_id: PropTypes.string,
  category_one: PropTypes.string,
  category_two: PropTypes.string,
  category_three: PropTypes.string,
  category_four: PropTypes.string,
  category_five: PropTypes.string,
  category_six: PropTypes.string,
  category_seven: PropTypes.string,
};

const propTypesItemsBenchmarkGrid = {
  column_title: PropTypes.string.isRequired,
  column_logo: PropTypes.shape(propTypesIllustration).isRequired,
  category_one_content: PropTypes.shape(propTypesTextHtml),
  category_one_rate: PropTypes.string,
  category_two_content: PropTypes.shape(propTypesTextHtml),
  category_two_rate: PropTypes.string,
  category_three_content: PropTypes.shape(propTypesTextHtml),
  category_three_rate: PropTypes.string,
  category_four_content: PropTypes.shape(propTypesTextHtml),
  category_four_rate: PropTypes.string,
  category_five_content: PropTypes.shape(propTypesTextHtml),
  category_five_rate: PropTypes.string,
  category_six_content: PropTypes.shape(propTypesTextHtml),
  category_six_rate: PropTypes.string,
  category_seven_content: PropTypes.shape(propTypesTextHtml),
  category_seven_rate: PropTypes.string,
  category_height_content: PropTypes.shape(propTypesTextHtml),
  category_height_rate: PropTypes.string,
  category_nine_content: PropTypes.shape(propTypesTextHtml),
  category_nine_rate: PropTypes.string,
  cta: PropTypes.shape(propTypesTextHtml),
};

export const propTypesDataBenchmarkGrid = {
  id: PropTypes.string,
  slice_type: PropTypes.string,
  slice_label: PropTypes.string,
  primary: PropTypes.shape(propTypesSliceBenchmarkGrid),
  items: PropTypes.arrayOf(PropTypes.shape(propTypesItemsBenchmarkGrid)),
};
